var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex h-13",
      on: {
        mouseover: function($event) {
          _vm.hoverState = true
        },
        mouseleave: function($event) {
          _vm.hoverState = false
        }
      }
    },
    [
      _c("div", { staticClass: "sticky left-0 z-10 flex pl-6 bg-pure-white" }, [
        _c(
          "div",
          {
            staticClass:
              "flex items-center flex-shrink-0 px-4 transition-all duration-300 border-b border-l w-14 border-slate-400",
            class: [
              _vm.isLast ? "rounded-bl" : "",
              _vm.hoverState ? "bg-hover-state" : "bg-pure-white"
            ]
          },
          [
            _c("BlInputCheck", {
              attrs: {
                checked: _vm.checked,
                title:
                  _vm.report.status !== "published"
                    ? "You can only download reports that have been published"
                    : ""
              },
              on: {
                changed: function($event) {
                  return _vm.$emit("change-selected")
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "flex items-center flex-shrink-0 gap-2 px-4 transition-all duration-300 border-b border-r w-60 border-slate-400",
            class: [_vm.hoverState ? "bg-hover-state" : "bg-pure-white"]
          },
          [
            _c("BlTextBody2", {
              staticClass: "truncate text-slate-1000",
              attrs: { title: _vm.report.name, text: _vm.report.name }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex items-center flex-shrink-0 w-40 px-4 transition-all duration-300 border-b border-slate-400",
          class: [_vm.hoverState ? "bg-hover-state" : "bg-pure-white"]
        },
        [_c("BlChip", { attrs: { chip: _vm.report.status, dense: "" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex items-center flex-shrink-0 w-56 px-4 transition-all duration-300 border-b border-slate-400",
          class: [_vm.hoverState ? "bg-hover-state" : "bg-pure-white"]
        },
        [
          _c("BlTextBody2", {
            staticClass: "truncate",
            attrs: { title: _vm.dateRange, text: _vm.dateRange }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex items-center flex-shrink-0 w-56 px-4 transition-all duration-300 border-b border-slate-400",
          class: [_vm.hoverState ? "bg-hover-state" : "bg-pure-white"]
        },
        [
          _c("BlTextBody2", {
            staticClass: "truncate",
            attrs: { title: _vm.templateType, text: _vm.templateType }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex items-center flex-shrink-0 px-4 transition-all duration-300 border-b w-50 border-slate-400",
          class: [_vm.hoverState ? "bg-hover-state" : "bg-pure-white"]
        },
        [
          !_vm.report.user_id
            ? _c("BlTextBody2", {
                staticClass: "italic truncate",
                attrs: { title: "Deleted user", text: "Deleted user" }
              })
            : _c(
                "div",
                {
                  staticClass:
                    "flex items-center justify-center h-8 px-3 truncate border rounded bg-success-100 border-success-100 max-w-25",
                  attrs: { title: _vm.report.user.name }
                },
                [
                  _c("BlTextBody1", {
                    staticClass: "truncate text-success",
                    attrs: { text: _vm.report.user.name }
                  })
                ],
                1
              )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex items-center flex-shrink-0 px-4 transition-all duration-300 border-b w-50 border-slate-400",
          class: [_vm.hoverState ? "bg-hover-state" : "bg-pure-white"]
        },
        [
          _c("BlTextBody2", {
            staticClass: "truncate",
            attrs: { title: _vm.dateUpdated, text: _vm.dateUpdated }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex items-center flex-shrink-0 px-4 transition-all duration-300 border-b w-50 border-slate-400",
          class: [_vm.hoverState ? "bg-hover-state" : "bg-pure-white"]
        },
        [
          !_vm.report.updated_by_user_id
            ? _c("BlTextBody2", {
                staticClass: "italic truncate",
                attrs: { text: "-" }
              })
            : _c("BlTextBody2", {
                staticClass: "truncate",
                class: { " italic": !_vm.report.updated_by_user.name },
                attrs: {
                  title: _vm.report.updated_by_user.name || "Deleted user",
                  text: _vm.report.updated_by_user.name || "Deleted user"
                }
              })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sticky right-0 z-10 flex flex-grow pr-6 bg-pure-white"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex items-center justify-end flex-grow flex-shrink-0 gap-2 px-4 transition-all duration-300 border-b border-r w-60 border-slate-400",
              class: [
                _vm.isLast ? "rounded-br" : "",
                _vm.hoverState ? "bg-hover-state" : "bg-pure-white"
              ]
            },
            [
              _vm.report.status === "published"
                ? _c("BlInputButton", {
                    attrs: {
                      type: "outlined",
                      dense: "",
                      label: "Download",
                      loading: _vm.downloadLoading
                    },
                    on: { clicked: _vm.onDownload }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.report.status === "published"
                ? _c("BlInputButton", {
                    attrs: { type: "outlined", dense: "", label: "Share" },
                    on: {
                      clicked: function($event) {
                        _vm.shareOpened = true
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.report.status === "published"
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        to: "/report/" + _vm.report.slug,
                        target: "_blank"
                      }
                    },
                    [
                      _c("BlInputButton", {
                        attrs: { type: "outlined", dense: "", label: "View" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.report.status === "unpublished"
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        to:
                          "/clients/" +
                          _vm.client.id +
                          "/report/" +
                          _vm.report.slug +
                          "/edit"
                      }
                    },
                    [
                      _c("BlInputButton", {
                        attrs: { type: "outlined", dense: "", label: "Edit" }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.shareOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: { title: "Share report", cancelLabel: "Close" },
              on: {
                "backdrop-close": function($event) {
                  _vm.shareOpened = false
                }
              }
            },
            [
              _c("div", { staticClass: "px-4 lg:px-8 lg:w-160" }, [
                _c(
                  "div",
                  { staticClass: "mb-3" },
                  [
                    _c("BlTextBody2", { attrs: { text: "Share" } }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "font-bold",
                      attrs: { text: _vm.report.name }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      attrs: {
                        text:
                          "with your clients by copying the link or saving the QR code below."
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "relative flex items-end gap-2 mb-3 cursor-pointer",
                    on: { click: _vm.copyToClipboard }
                  },
                  [
                    _c("BlInputText", {
                      staticClass: "pr-8",
                      attrs: { input: _vm.linkInput }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "absolute right-1" },
                      [
                        _c("BlInputButton", {
                          attrs: { icon: "copy", type: "plain" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex flex-col items-center justify-center gap-3"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "p-4",
                        attrs: { id: "qr-code-" + _vm.report.id }
                      },
                      [
                        _c("QrcodeVue", {
                          attrs: {
                            value: _vm.linkInput.model,
                            size: 200,
                            level: "L"
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-97391772", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97391772","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/report/Item.vue
// module id = null
// module chunks = 